import React, { useEffect } from "react";
import "./style.scss";

// «Взрыв» баллов при начислении (ТЗ п.6.6): CSS-партиклы без внешних библиотек.
// Рендерится поверх блока баланса в ЛК; сам гасится по завершении анимации.
const PARTICLES = Array.from({ length: 14 }, (_, i) => i);

export default function PointsBurst({ amount, onDone }) {
  useEffect(() => {
    const timer = setTimeout(() => onDone && onDone(), 1800);
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <div className="points-burst" aria-hidden="true">
      <div className="points-burst__amount">+{amount}</div>
      {PARTICLES.map((i) => (
        <span
          key={i}
          className="points-burst__particle"
          style={{
            "--angle": `${(360 / PARTICLES.length) * i}deg`,
            "--delay": `${(i % 4) * 60}ms`,
          }}
        />
      ))}
    </div>
  );
}
